<template lang="html">
  <v-card>
    <v-card-text>
      <v-layout row wrap class="pt-3">
        <v-flex xs6 md3 style="font-size: 25px;">
          <Gauge
            :value="machine.overall"
            label="Overall"
            :forceGray="!machine.total_pallets"
          />
        </v-flex>
        <v-flex xs6 md3 style="font-size: 25px; cursor: pointer;">
          <Gauge
            :value="revolutionsPerformance"
            label="Revs"
            :loading="loading"
            :error="error"
            @click="openGraph('revolutions')"
          />
        </v-flex>
        <v-flex xs6 md3 style="font-size: 25px; cursor: pointer;">
          <Gauge
            :value="appliedStretchPerformance"
            label="Stretch"
            :loading="loading"
            :forceGray="false"
            :error="error"
            @click="openGraph('applied_stretch')"

          />
        </v-flex>
        <v-flex xs6 md3 style="font-size: 25px; cursor: pointer;">
          <Gauge
            :value="unwindLengthPerformance"
            label="Unwind"
            :loading="loading"
            :forceGray="false"
            :error="error"
            @click="openGraph('unwind_length')"
          />
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex
          xs6
          md2
          v-for="indicator in indicators"
          :key="indicator.key"
        >
          <Indicator
            :label="indicator.name"
            :loading="loading"
            :value="`${indicator.value ? indicator.value() : round(data[indicator.key] || 0).toLocaleString()}${indicator.unit ? ' ' + unitName(indicator.unit) : ''}`"
            :lengthy="!!indicator.lengthy || !!indicator.unit"
            :error="error"
          />
        </v-flex>
      </v-layout>
    </v-card-text>
  </v-card>
</template>

<style lang="scss" scoped>
</style>

<script>
import Gauge from './Gauge'
import Indicator from './Indicator'
import axios from 'axios'
import get from 'lodash/get'
import parseSeconds from 'parse-seconds'
import moment from 'moment-timezone'
import round from 'lodash/round'

export default {
  components: {
    Gauge,
    Indicator
  },
  props: {
    machine: {
      type: Object,
      required: true
    },
    dateRange: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      loading: false,
      data: {},
      error: null
    }
  },
  computed: {
    indicators () {
      let indicators = [
        { name: 'Loads', key: 'loads' },
        { name: 'Flagged Loads', key: 'flagged_total' },
        { name: 'Stretch', key: 'stretch_pct_avg' },
        { name: 'Film Weight', key: 'film_weight', unit: 'oz' },
        {
          name: 'Uptime',
          key: 'uptime',
          lengthy: true,
          value: () => {
            let seconds = (this.data && this.data.wrap_time) || 0
            if (!seconds) {
              return 0
            }
            return Object.entries(parseSeconds({ years: false, weeks: false })(seconds)).filter(([key, value]) => value > 0).map(([key, value]) => {
              return value + key.substr(0, 1)
            }).join(' ')
          }
        },
        {
          name: 'Downtime',
          key: 'downtime',
          lengthy: true,
          value: () => {
            let timeframeSeconds = moment(this.dateRange.end).unix() - moment(this.dateRange.start).unix()
            let uptimeSeconds = (this.data && this.data.wrap_time) || 0
            let seconds = timeframeSeconds - uptimeSeconds
            if (!seconds) {
              return 0
            }
            return Object.entries(parseSeconds({ years: false, weeks: false })(seconds)).filter(([key, value]) => value > 0).map(([key, value]) => {
              return value + key.substr(0, 1)
            }).join(' ')
          }
        }
      ]
      return indicators
    },
    requestParams () {
      return {
        machines: this.machine.id,
        fromDate: moment(this.dateRange.start).format('YYYY-MM-DD[T]HH:mm:ss'),
        toDate: moment(this.dateRange.end).format('YYYY-MM-DD[T]HH:mm:ss'),
        archive: 1
      }
    },
    revolutionsPerformance () {
      if (!(this.data && this.data.loads && this.data.loads > 0)) {
        return 0
      }
      return round(100 * ((this.data.loads - ((this.data && this.data.alarm_revolution) || 0)) / this.data.loads))
    },
    appliedStretchPerformance () {
      if (!(this.data && this.data.loads && this.data.loads > 0)) {
        return 0
      }
      return round(100 * ((this.data.loads - ((this.data && this.data.alarm_stretch) || 0)) / this.data.loads))
    },
    unwindLengthPerformance () {
      if (!(this.data && this.data.loads && this.data.loads > 0)) {
        return 0
      }
      return round(100 * ((this.data.loads - ((this.data && this.data.alarm_unwind_length) || 0)) / this.data.loads))
    }
  },
  methods: {
    round,
    async loadData () {
      if (this.machine.noTotal || !this.dateRange.start || !this.dateRange.end || !(this.machine && this.machine.id)) {
        return
      }
      this.loading = true
      try {
        let response = await axios({
          method: 'GET',
          url: `/rest/machine/${this.machine.id}/data/totals`,
          params: this.requestParams
        })
        this.data = get(response, 'data') || {}
        this.loading = false
      } catch (e) {
        this.error = e.message
        this.loading = false
        throw e
      }
    },
    openGraph (testType) {
      this.$emit('openGraph', {
        testType,
        machine: this.machine.id,
        dateRange: {
          ...this.dateRange,
          range: null
        }
      })
    }
  },
  async created () {
    await this.loadData()
  }
}
</script>
